import { connect } from 'react-redux';
import Inspection from './Inspection';
import {
    getUserList,
    getLoadMoreInspection,
    getInspectionCount,
    getInspectionColumnFields,
} from '../../../../store/selectors/license.selectors';
import { getAppointmentInspectionCount } from '../../../../store/selectors/person.selectors';
import { getUserListBegin } from '../../../../store/actions/license.actions';
import { getAuthenticationToken } from '../../../../store/actions/authentication.actions';

const mapStateToProps = (state: any) => {
    const userList = getUserList(state);
    const users = getUserList(state);
    const hasMoreInspection = getLoadMoreInspection(state);
    const inspectionCountForLicense = getInspectionCount(state);
    const inspectionColumnFields = getInspectionColumnFields(state);
    const inspectionCountForAppointment = getAppointmentInspectionCount(state);
    return {
        users,
        userList,
        hasMoreInspection,
        inspectionColumnFields,
        inspectionCountForLicense,
        inspectionCountForAppointment,
    };
};
const mapDispatchToProps = {
    getAuthenticationToken: getAuthenticationToken,
    getUserList: getUserListBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(Inspection);
